/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetPublicDocumentForEntityByHash$Params {

/**
 * the documentHash
 */
  downloadHash: string;
}

export function getPublicDocumentForEntityByHash(http: HttpClient, rootUrl: string, params: GetPublicDocumentForEntityByHash$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getPublicDocumentForEntityByHash.PATH, 'get');
  if (params) {
    rb.path('downloadHash', params.downloadHash, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getPublicDocumentForEntityByHash.PATH = '/public/documents/{downloadHash}';
